module.exports = __webpack_public_path__ + "fonts/GothamRounded-Bold.542decf6.woff2";